var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRevenue = function SvgRevenue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 23.761",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "1000x1000_sparschwein-active"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.941 3.129a1.964 1.964 0 1 0 2.656-.813 1.964 1.964 0 0 0-2.656.813",
    "data-name": "Pfad 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.387 1.042a1.964 1.964 0 1 0 2.661-.814 1.964 1.964 0 0 0-2.656.814Z",
    "data-name": "Pfad 57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.717 15.475a.98.98 0 0 1-.794.352h-.337a6.76 6.76 0 0 1-1.737 3.372.4.4 0 0 0-.1.164l-1.162 3.821a.81.81 0 0 1-.779.577h-1.142a.83.83 0 0 1-.8-.592l-.419-1.43a.14.14 0 0 0-.128-.089H12.3a9.6 9.6 0 0 1-3.594 0H8.68a.13.13 0 0 0-.128.089l-.421 1.438a.81.81 0 0 1-.779.585H6.176a.81.81 0 0 1-.779-.577l-.87-2.867a.44.44 0 0 0-.226-.254 14.5 14.5 0 0 1-3.73-2.367 1.7 1.7 0 0 1-.57-1.259v-2.307a1.19 1.19 0 0 1 1.19-1.19h.734a7.5 7.5 0 0 0 1.347-1.618c.059-.1.119-.188.188-.285a2.77 2.77 0 0 0-.817-1.574.69.69 0 0 1-.149-.727.72.72 0 0 1 .6-.456q.224-.012.449-.014a4.1 4.1 0 0 1 2.143.561.18.18 0 0 0 .2 0 9.1 9.1 0 0 1 4.593-1.224c4.061 0 7.514 2.592 8.105 6.069h.285a1.11 1.11 0 0 1 1.124.974 1.03 1.03 0 0 1-.276.829ZM6.332 13.731a.93.93 0 1 0-.575.855.93.93 0 0 0 .576-.856Z",
    "data-name": "Pfad 58"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRevenue);
export default ForwardRef;